import { Anchor, Flex, FormStatus, Ul } from '@dnb/eufemia';
import { JWT_ERROR_MESSAGES, JwtErrorCode } from '@portals/shared/common/utils';
import { Link } from 'react-router-dom';

interface JwtValidationResultsProps {
  errors: JwtErrorCode[];
  hasEnvironmentMismatch: boolean;
  token?: string;
}

export function JwtValidationResults({ errors, hasEnvironmentMismatch, token }: JwtValidationResultsProps) {
  if (errors.length === 0 && !hasEnvironmentMismatch) {
    return null;
  }

  const validatorUrl = token ? `/jwt-validator?token=${encodeURIComponent(token)}` : '/jwt-validator';

  return (
    <Flex.Stack space="small" top="small">
      {errors.length > 0 && (
        <FormStatus state="error" stretch>
          JWT Validation Errors:
          <Ul top="x-small">
            {errors.map((errorCode) => (
              <li key={errorCode}>{JWT_ERROR_MESSAGES[errorCode]}</li>
            ))}
          </Ul>
        </FormStatus>
      )}

      {hasEnvironmentMismatch && (
        <FormStatus state="error" stretch>
          Your JWT is valid, but the audience environment does not match the selected client environment.
        </FormStatus>
      )}

      <FormStatus state="information" stretch>
        Need help debugging?{' '}
        <Anchor element={Link} target="_blank" to={validatorUrl}>
          View detailed token analysis in JWT Validator
        </Anchor>
      </FormStatus>
    </Flex.Stack>
  );
}
